import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext'; // Use AuthContext instead of direct auth
import { fetchLogs } from '../services/api';
import './LogsPage.css';

function LogsPage() {
  const { user } = useContext(AuthContext); // Use AuthContext for consistency
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user has permission to view logs
    if (!user || user.role !== 'admin') {
      navigate('/unauthorized');
      return;
    }

    const loadLogs = async () => {
      try {
        setLoading(true);
        const response = await fetchLogs();
        console.log('API Response:', response);
        setLogs(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error('Error fetching logs:', error);
        setError('Failed to load logs. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    loadLogs();
  }, [user, navigate]);

  // Show loading state
  if (loading) {
    return (
      <div className="logs-page">
        <div className="loading-container">
          <h1>Action Logs</h1>
          <p>Loading logs...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="logs-page">
      <div className="logs-header">
        <h1>Action Logs</h1>
        <button 
          onClick={() => navigate('/dashboard')} 
          className="back-button"
        >
          ← Back to Dashboard
        </button>
      </div>

      <div className="logs-content">
        {error ? (
          <div className="error-container">
            <p className="error-message">{error}</p>
            <button 
              onClick={() => window.location.reload()} 
              className="retry-button"
            >
              Retry
            </button>
          </div>
        ) : logs.length === 0 ? (
          <div className="no-logs-container">
            <p>No logs available.</p>
          </div>
        ) : (
          <div className="logs-table-container">
            <table className="logs-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>User Email</th>
                  <th>Action Type</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id}>
                    <td>{new Date(log.created_at).toLocaleString()}</td>
                    <td>{log.user_email}</td>
                    <td>
                      <span className={`action-type ${log.action_type.toLowerCase().replace(/\s+/g, '-')}`}>
                        {log.action_type}
                      </span>
                    </td>
                    <td>{log.action_details}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default LogsPage;
